import React, { useContext, useEffect, useState, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useForm, useFieldArray } from 'react-hook-form';

import { AppContext } from '../../App';

import InputField from '../components/InputField';
import SelectField from '../components/SelectField';
import TextAreaField from '../components/TextAreaField';
import CheckboxField from '../components/CheckboxField';
import UploadField from '../components/UploadField';
import RadioField from '../components/RadioField';
import CustomDatePicker from '../components/CustomDatePicker';
import StepProgressBar from '../components/StepProgressBar';
import Modal from '../components/Modal';

const CourseApplication = () => {
  const { courseId } = useParams();
  const appContext = useContext(AppContext);
  const [formHidden, setFormHidden] = useState(false);
  
  useEffect(() => {
    // Fetch student's course status
    appContext.httpClient.get({
      path: "courseapplication/myapplications",
      authRedirectPath: appContext.loginPath
    }).then(response => {
      if (response.success && response.result) {        
        const course = response.result.find(c => c.courseId == courseId);
        const hiddenStatuses = ['ACCEPTED', 'ENROLLED', 'PENDING', 'BANNED'];        
        setFormHidden(course != null && hiddenStatuses.includes(course.statusCodeName));
      }
    });
  }, [appContext.apiBaseUrl, courseId]);

  useEffect(() => {
      if (courseId && !isInitRequested) {
        setIsInitRequested(true);
          appContext.httpClient.get({
              path: "courseapplication/formdata/" + courseId,
              authRedirectPath: appContext.loginPath
          }).then(response => {
              console.log(response.result)
              if (response.result) {     
                const course = response.result.course;
                console.log(response.result);
                setFormData(response.result);
                setAreAllModulesRequired(course.allModulesRequired);
                setNumberOfEducationFields(course.courseEducation);
                setNumberOfProfessionalQualificationFields(course.courseQualifications)

                if (Array.isArray(course.entryCriteria) && course.entryCriteria.length) {                  
                  setValue("entryCriteria", course.entryCriteria);
                }

                if (Array.isArray(course.moduleGroups) && course.moduleGroups.length) {                  
                  setValue("moduleGroups", course.moduleGroups);

                  const compulsoryModules = [];
                  course.moduleGroups.forEach(group => {
                    if (group.requirementCodeName === "compulsory") {
                      group.modules.forEach(module => {
                        compulsoryModules.push({
                          courseModuleId: module.courseModuleId,
                          courseModuleGroupId: module.courseModuleGroupId,
                          type: "compulsory",
                          selected: true
                        });
                      });
                    }
                  });
                  debugger;
                  setSelectedModules(compulsoryModules);            
                  updateModuleCounts(compulsoryModules);
                  setValue("modules", compulsoryModules, { shouldValidate: true });
                }

                const generateEducationFields = (numFields) => {
                  return Array.from({ length: numFields }, () => ({
                    degree: '',
                    yearAwarded: '',
                    collegeUniversity: '',
                    languageOfInstruction: '',
                    degreeUpload: '',
                  }));
                };

                const generateProfessionalQualificationsFields = (numFields) => {
                  return Array.from({ length: numFields }, () => ({
                    qualificationDescription: '',
                    qualificationDate: '',
                    profession: '',
                    practicing: false
                  }));
                };
                
                // Example usage:
                const courseEducation = response.result.course.courseEducation; // This value could be dynamic
                const educationDefaultValues = generateEducationFields(courseEducation);
                setValue('educationHistory', educationDefaultValues);

                // Doing the same for professional quals:
                const courseQualifications = response.result.course.courseQualifications; // This value could be dynamic
                const professionalQualificationsDefaultValues = generateProfessionalQualificationsFields(courseQualifications);
                setValue('qualifications', professionalQualificationsDefaultValues);
                
                getDraft(response.result);
              }
          });
      }  
  }, [appContext.apiBaseUrl]);

  const [selectedModules, setSelectedModules] = useState([]);
  const [selectedModuleCount, setSelectedModuleCount] = useState(0);
  const [selectedElectiveCount, setSelectedElectiveCount] = useState(0);
  const [selectedAbCompulsoryCount, setSelectedAbCompulsoryCount] = useState(0);
  const [selectedAdditionalModules, setSelectedAdditionalModules] = useState(0);


  const { register, handleSubmit, control, getValues, setValue, reset, watch, trigger, formState: { errors } } = useForm({
    defaultValues: {
      workExperience: [{
        company: '',
        companyAddress1: '',
        companyAddress2: '',
        companyCity: '',
        companyState: '',
        companyPostcode: '',
        companyCountry: '',
        jobTitle: '',
        typeOfOrganisationId: 0,
        typeOfOrganisationOther: '',
        startDate: null,
        jobDescription: ''
      }],
      educationHistory: [],
      entryCriteria: [],
      qualifications: [{
        qualificationDescription: '',
        qualificationDate: null,
        profession: ''
      }],
      references: [{}, {}],
      moduleGroups: [],
      //modules: [],
      modules: selectedModules.map(m => m.courseModuleId),
      paymentMethod: 'CARD',
      courseApplicationId: 0
    }});

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [areAllModulesRequired, setAreAllModulesRequired] = useState(true);
  const [isDifferentEmailChecked, setDifferentEmailChecked] = useState(false);
  const [isPostalAddressChecked, setPostalAddressChecked] = useState(false);
  const [whoWillPayOther, setWhoWillPayOther] = useState(false);
  const [isTypeOfOrganisationOther, setIsTypeOfOrganisationOther] = useState([]);
  //const [isDegreeUploadChecked, setDegreeUploadChecked] = useState(false);
  const [isIeltsOrToeflChecked, setIeltsOrToeflChecked] = useState(false);
  const [numberOfEducationFields, setNumberOfEducationFields] = useState(1);
  const [numberOfProfessionalQualificationFields, setNumberOfProfessionalQualificationFields] = useState(1);
  const [module2, setModule2] = useState(null);
  const [step, setStep] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showFormErrorModal, setShowFormErrorModal] = useState(false);
  const [formError, setFormError] = useState(false);
  const [showPaymentPreviewModal, setShowPaymentPreviewModal] = useState(false);
  const [paymentPreview, setPaymentPreview] = useState(false);
  const [confirmPaymentPreview, setConfirmPaymentPreview] = useState(false);
  const [isInitRequested, setIsInitRequested] = useState(false);
  const [activeStep, setActiveStep] = useState("Personal Information");
  const [formData, setFormData] = useState({
    personTitles: [],
    countries: [],
    fundingTypes: [],
    genders: [],
    organisationTypes: [],
    course: {
      courseTitle: ''
    }
  });
  const [paymentMethod, setPaymentMethod] = useState('card');
  const [isBursaryDiscountChecked, setBursaryDiscountChecked] = useState(false);
  const [validatedSteps, setValidatedSteps] = useState([]);
  const [savedDraft, setSavedDraft] = useState(null);

  const showErrorsForStep = (currentStep) => {
  return validatedSteps.includes(currentStep);
};


  const formRef = useRef(null);

  useEffect(() => {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [step]);

  const {
    fields: companyFields,
    append: appendCompany,
    remove: removeCompany
  } = useFieldArray({
    control,
    name: 'workExperience'
  });

  const {
    fields: educationFields,
    append: appendEducation,
    remove: removeEducation
  } = useFieldArray({
    control,
    name: 'educationHistory'
  });

  const {
    fields: professionalFields,
    append: appendProfessional,
    remove: removeProfessional
  } = useFieldArray({
    control,
    name: 'qualifications'
  });

  const {
    fields: entryCriteriaFields
  } = useFieldArray({
    control,
    name: 'entryCriteria'
  });

  const {
    fields: referencesFields
  } = useFieldArray({
    control,
    name: 'references'
  });

  const {
    fields: modulesFields
  } = useFieldArray({
    control,
    name: 'moduleGroups'
  });

  const handleDifferentEmailChecked = (e) => {
    setDifferentEmailChecked(e.target.checked);
  };

  const handlePostalAddressChecked = (e) => {
    setPostalAddressChecked(e.target.checked);
  };

  const handleWhoWillPayOther = (e) => {
    const selectedValue = e.target.value;
    setWhoWillPayOther(selectedValue);
    setValue("fundingId", selectedValue, { shouldValidate: true });
  };

  const handleTypeOfOrganisationOther = (e, index) => {
    const selectedValue = e.target.value;
    const updatedState = [...isTypeOfOrganisationOther];
    updatedState[index] = e.target.getAttribute("data-code-name") === 'OTHER';
    setIsTypeOfOrganisationOther(updatedState);
    setValue(`workExperience[${index}].typeOfOrganisationId`, selectedValue, { shouldValidate: true });
  };

  const handleEntryCriteriaChecked = (e, index) => {
    const { name, checked } = e.target;

    // Get the current values of both checkboxes
    const otherOptionName = name.endsWith('.option1') ? `entryCriteria[${index}].option2` : `entryCriteria[${index}].option1`;

    // Uncheck the other option
    setValue(otherOptionName, false);
    // Update the value of the clicked checkbox
    setValue(name, checked);
};

  const handleIeltsOrToeflChecked = (e) => {
    setIeltsOrToeflChecked(e.target.checked);
  };

  const handleModule2AChange = () => {
      setModule2(module2 === '2A' ? null : '2A');
      console.log(module2)
  };

  const handleModule2BChange = () => {
    setModule2(module2 === '2B' ? null : '2B');
    console.log(module2)
  };

  const handlePaymentMethod = (e) => {
    setPaymentMethod(e.target.value);
  };

  const handleBursaryDiscount = (e) => {
    setBursaryDiscountChecked(e.target.checked);
  };

  const handleCloseFormErrorModal = () => {
    setShowFormErrorModal(false);
  };

  const handleClosePaymentPreviewModal = () => {
    setShowPaymentPreviewModal(false);
    setConfirmPaymentPreview(false);
    setIsSubmitting(false);
    submitRef.current = false;
  };

  const handleContinuePayment = () => {
    if (isSubmitting) return;
    setConfirmPaymentPreview(true);
    setShowPaymentPreviewModal(false);
  };

  const addCompany = () => {
    appendCompany({
      company: '',
      companyAddress1: '',
      companyAddress2: '',
      companyCity: '',
      companyState: '',
      companyPostcode: '',
      companyCountry: '',
      jobTitle: '',
      typeOfOrganisationId: 0,
      typeOfOrganisationOther: '',
      startDate: null,
      jobDescription: ''
    });
  };

  const addEducation = () => {
    appendEducation({
      description: '',
      yearAwarded: '',
      collegeUniversity: '',
      language: '',
      file: ''
    });
  };

  const addProfessional = () => {
    appendProfessional({
      qualificationDescription: '',
      qualificationDate: '',
      profession: '',
      practicing: false
    });
  };

  const getErrorMessage = (list, index, field) => {
    return errors[list] &&
    errors[list].length > index &&
    errors[list][index] &&
    errors[list][index][field] &&
    errors[list][index][field].message;
  }

  
  const updateModuleCounts = (modules) => {
    const { abCompulsoryCount, compulsoryCount, electiveCount, additionalModuleCount } = getModuleCounts(modules);
    setSelectedModuleCount(compulsoryCount + electiveCount);
    setSelectedElectiveCount(electiveCount);
    setSelectedAbCompulsoryCount(abCompulsoryCount);
    setSelectedAdditionalModules(additionalModuleCount);
  };

  const getModuleCounts = (modules) => {
    const totalModules = modules.length;
    const additionalModuleCount = Math.max(0, totalModules - formData.course.courseMinModules);
    let compulsoryCount = 0;
    let electiveCount = 0;
    let abCompulsoryCount = 0;

    // Check for "ab-compulsory" groups
    const abCompulsoryGroups = modulesFields.filter(group => group.requirementCodeName === "ab-compulsory");
    abCompulsoryGroups.forEach(group => {
      const selectedFromGroup = modules.filter(m => m.courseModuleGroupId === group.courseModuleGroupId);
      if (selectedFromGroup.length > 0) {
        abCompulsoryCount += 1;
        selectedFromGroup.forEach((module, index) => {
          module.type = index === 0 ? "compulsory" : "elective";
        });
      }
    });

    const abGroups = [];
    modules.forEach(module => {
      if (module.moduleRequirementCodeName === "ab-compulsory") {
        if (!abGroups.includes(module.courseModuleGroupId)) {
          abGroups.push(module.courseModuleGroupId);
          compulsoryCount += 1;
        }
        else {
          module.type = "elective";
          electiveCount += 1;
        }
      }
      else if (module.type === "compulsory") {
        compulsoryCount += 1;
      }
      else if (module.type === "elective") {
        electiveCount += 1;
      }
    });
    return {
      abCompulsoryCount,
      compulsoryCount,
      electiveCount,
      additionalModuleCount
    }
  } 
  
  const submitRef = useRef(false);

  const handlePaymentPreview = async (revisedData) => {
    const isStepValid = await trigger();

    // Mark this step as validated
    setValidatedSteps((prev) => [...new Set([...prev, step])]);

    if (!isStepValid) {
      console.warn("Validation failed on payment step");
      return false;
    }
    try {
      const paymentResponse = await appContext.httpClient.post({
        path: "courseapplication/paymentinfo",
        body: revisedData,
      });

      if (paymentResponse.success && paymentResponse.result) {
        console.log("Payment Info:", paymentResponse.result);
        setPaymentPreview(paymentResponse.result);
        setShowPaymentPreviewModal(true);
        return true;
      } else {
        console.error("Failed to retrieve payment info");
        setFormError("Failed to retrieve payment information.");
        setShowFormErrorModal(true);
        return false;
      }
    } catch (error) {
      console.error("Error fetching payment info:", error);
      setFormError("A network error occurred while retrieving payment information.");
      setShowFormErrorModal(true);
      return false;
    }
  };

  const getRevisedDataForSave = (data, isDraft) => {
    const revisedData = {
      ...data,
      courseId,
      userId: appContext.userId,
      modules: selectedModules,
      moduleGroups: null
    }

    if (revisedData.entryCriteria?.length) {
      revisedData.entryCriteria.forEach(ec => {
        ec.selection = parseInt(ec.selection) || 0;
      })
    }

    if (revisedData.qualifications?.length) {
      revisedData.qualifications.forEach(q => {
        q.practicing = q.practicing === true || q.practicing === "true";
        q.startDate = q.startDate
      });

      if (isDraft)
        revisedData.qualifications = revisedData.qualifications.filter(q => {
          return q.qualificationDescription;
        });
    }

    if (isDraft) {
      if (revisedData.workExperience?.length) {
        revisedData.workExperience.forEach(we => we.companyCountryId = parseInt(we.companyCountryId || 0));
        revisedData.workExperience = revisedData.workExperience.filter(we => {
            return we.company && we.jobDescription;
        });
      }

      if (revisedData.educationHistory?.length) {
        revisedData.educationHistory.forEach(eh => eh.yearAwarded = parseInt(eh.yearAwarded || 0));
        revisedData.educationHistory = revisedData.educationHistory.filter(eh => {
            return eh.description && eh.language && eh.collegeUniversity;
        });
      }

      if (revisedData.references?.length) {
        revisedData.references = revisedData.references.filter(r => {
            return r.title && r.firstName && r.lastName && r.email;
        });
      }

      if (savedDraft) {
          applyDraftIdentifiers(revisedData, savedDraft);
      }

      revisedData.industryExperienceYears = parseInt(revisedData.industryExperienceYears) || 0;
      revisedData.industryExperienceSummary = revisedData.industryExperienceSummary || "";
      revisedData.yearsToComplete = parseInt(revisedData.yearsToComplete) || 1;
      revisedData.fundingId = parseInt(revisedData.fundingId) || 0;
    }

    return revisedData;
  }

  const onSubmit = async (data) => {
    if (submitRef.current || isSubmitting) return;
    submitRef.current = true;
    setIsSubmitting(true);

    const userId = appContext.userId;

    console.log(selectedModules)

    const revisedData = getRevisedDataForSave(data);

    console.log("courseId" + courseId)
    console.log("userId" + userId)
    console.log(revisedData);

    try {
      // Only proceed if there are no validation errors
      if (Object.keys(errors).length > 0) {
        console.log("Form has errors:", errors);
        return;
      }

      if (filteredSteps[step]?.title !== "Payment") {
        // Move to the next step if not on the payment step
        console.log("Moving to next step");
        setStep(step + 1);
        return;
      }

      // Proceed with form submission if payment preview is confirmed
      if(confirmPaymentPreview) {
        // Post the form data to the server
        const response = await appContext.httpClient.post({
          path: "courseapplication",
          body: revisedData
        });
  
        // Check if the response was successful
        if (response.success) {
          console.log("Form submitted successfully:", response);
          setIsSubmitted(true);
          setConfirmPaymentPreview(false);
        } else {
          //debugger;

          if (response.statusCode === 422 && response.validationResult?.errors?.USER_ALREADY_APPLIED) {
              // handle when the user has already applied
              //debugger;
          }

          // Handle server-side validation or processing errors
          console.log("Error submitting the form:", response.message || "Unknown error occurred.");
          // Display error message to the user (optional)
          setFormError(response.message || "An error occurred while submitting the form.");
          setShowFormErrorModal(true);
        }
      }

      
    } catch (error) {
        // Handle network or other unexpected errors
        console.error("Submission failed due to a network or server error:", error);
        setFormError("A network error occurred. Please try again later.");
        setShowFormErrorModal(true);
      } finally {
        setIsSubmitting(false);
        submitRef.current = false;
        setConfirmPaymentPreview(false);
      }

  };


  const handleBack = () => {
    setIsSubmitted(false);
    console.log("Current step before going back:", step);

    if (step > 0) {
        const newStep = step - 1;
        setStep(newStep);
        setActiveStep(filteredSteps[newStep].title)
        console.log("Updated step:", newStep);
    } else {
        console.log("Attempted to go back from the first step.");
    }
  };

  const [checkedEntryCriteria, setCheckedEntryCriteria] = useState({});

  const handleEntryCriteriaChange = (e, index) => {
      const { name, value, checked, type } = e.target;

      if (type === 'checkbox') {
        setCheckedEntryCriteria((prevState) => ({
          ...prevState,
          [index]: checked
        }));
        setValue(`entryCriteria[${index}].selection`, checked ? 1 : 0, { shouldValidate: true });
      } else if (type === 'radio') {
        // If it's a radio button, track the selected option value
        setCheckedEntryCriteria((prevState) => ({
          ...prevState,
          [index]: value
        }));
        setValue(`entryCriteria[${index}].selection`, value, { shouldValidate: true });
      }

      console.log(`Changed field at index ${index}:`, { name, value, checked });
  };

  const handleModuleSelectionChange = (e, courseModuleId, courseModuleGroupId, requirementCodeName) => {
    const { checked } = e.target;
    const moduleId = Number(courseModuleId);
  
    setSelectedModules((prevModules) => {
      let updatedModules;
  
      if (checked) {
        updatedModules = [...prevModules, { courseModuleId: moduleId, courseModuleGroupId: courseModuleGroupId, type: requirementCodeName, moduleRequirementCodeName: requirementCodeName }];
      } else {
        updatedModules = prevModules.filter(mod => mod.courseModuleId !== moduleId);
      }

      const { abCompulsoryCount, compulsoryCount, electiveCount, additionalModuleCount } = getModuleCounts(updatedModules);

      setSelectedModuleCount(compulsoryCount + electiveCount);
      setSelectedElectiveCount(electiveCount);
      setSelectedAbCompulsoryCount(abCompulsoryCount);
      setSelectedAdditionalModules(additionalModuleCount);
  
      setValue("modules", updatedModules, { shouldValidate: true });
  
      return updatedModules;
    });
  };

  const getModuleType = (courseModuleId, courseModuleGroupId, requirementCodeName) => {
    const isSelected = selectedModules.some(m => m.courseModuleId === courseModuleId);

    if (!isSelected) {
        return ""; // Hide type if module isn't selected
    }

    if (requirementCodeName === "ab-compulsory") {
        // Find all selected modules within this ab-compulsory group
        const selectedInGroup = selectedModules
            .filter(m => m.courseModuleGroupId === courseModuleGroupId)
            .map(m => m.courseModuleId);

        // Determine order of selection
        const index = selectedInGroup.indexOf(courseModuleId);

        // First selection in the group = compulsory, others = elective
        return index === 0 ? "- Compulsory" : "- Elective";
    }

    // For all other module types, just return their default requirementCodeName
    return `- ${requirementCodeName.charAt(0).toUpperCase() + requirementCodeName.slice(1)}`;
};


  const validateModules = () => {
    debugger;
    if (selectedModuleCount < formData.course.courseMinModules) {
      return `You must select at least ${formData.course.courseMinModules} modules before proceeding.`;
    }
    
    if (selectedElectiveCount < formData.course.courseMinElectiveModules) {
      return `You must select at least ${formData.course.courseMinElectiveModules} elective modules.`;
    }
  
    const abCompulsoryGroups = modulesFields.filter(group => group.requirementCodeName === "ab-compulsory");
    let abCompulsoryValid = abCompulsoryGroups.every(group =>
      selectedModules.some(module => module.courseModuleGroupId === group.courseModuleGroupId)
    );
  
    if (!abCompulsoryValid) {
      return "You must select at least one module from each 'ab-compulsory' group.";
    }
  
    return true;
  };

  const saveDraft = async () => {
    const formData = watch();
    const revisedData = getRevisedDataForSave(formData, true);

    const response = await appContext.httpClient.post({
      path: "courseapplication?isdraft=true",
      body: revisedData
    });

    if (response.success && response.result?.application) {
      setValue("courseApplicationId", response.result.application.courseApplicationId);
      setSavedDraft(response.result.application);
    }
  }

  const applyDraftIdentifiers = (payload, draft) => {
    if (payload.entryCriteria?.length) {
      for (let i = 0; i < payload.entryCriteria.length; i++) {
        if (!payload.entryCriteria[i].courseApplicationEntryCriteriaId)
          payload.entryCriteria[i].courseApplicationEntryCriteriaId =
            draft.entryCriteria[i].courseApplicationEntryCriteriaId;            
        if (draft.entryCriteria[i] && payload.entryCriteria[i].fileId != draft.entryCriteria[i].fileId) {
          payload.entryCriteria[i].fileId = draft.entryCriteria[i].fileId;          
          payload.entryCriteria[i].uploadId = null;
        }
      }
    }
    if (payload.workExperience?.length) {
      for (let i = 0; i < payload.workExperience.length; i++)
        if (!payload.workExperience[i].courseApplicationWorkExperienceId && draft.workExperience[i])
          payload.workExperience[i].courseApplicationWorkExperienceId =
            draft.workExperience[i].courseApplicationWorkExperienceId;
    }
    if (payload.educationHistory?.length) {
      for (let i = 0; i < payload.educationHistory.length; i++) {
        if (!payload.educationHistory[i].courseApplicationEducationId && draft.educationHistory[i])
          payload.educationHistory[i].courseApplicationEducationId =
            draft.educationHistory[i].courseApplicationEducationId;
        if (draft.educationHistory[i] && payload.educationHistory[i].fileId != draft.educationHistory[i].fileId) {
          payload.educationHistory[i].fileId = draft.educationHistory[i].fileId;
          payload.educationHistory[i].file.uploadId = null;
        }
      }
    }
    if (payload.qualifications?.length) {
      for (let i = 0; i < payload.qualifications.length; i++)
        if (!payload.qualifications[i].courseApplicationQualificationId && draft.qualifications[i])
          payload.qualifications[i].courseApplicationQualificationId =
            draft.qualifications[i].courseApplicationQualificationId;
    }
    if (payload.references?.length) {
      for (let i = 0; i < payload.references.length; i++)
        if (!payload.references[i].courseApplicationReferenceId && draft.references[i])
          payload.references[i].courseApplicationReferenceId =
            draft.references[i].courseApplicationReferenceId;
    }
  }

  const getDraft = async (formData) => {
    const response = await appContext.httpClient.get({
        path: `courseapplication/${courseId}/draft`,
        authRedirectPath: appContext.loginPath
    });
    if (response.success && response.result) {

      const draft = response.result;

      if (!draft.workExperience?.length) draft.workExperience = [{}];
      if (!draft.educationHistory?.length) draft.educationHistory = [{}];
      if (!draft.qualifications.length) draft.qualifications = [{}];
      if (!draft.references.length) draft.references = [{}, {}];
      if (draft.references.length < 2) draft.references.push({});
      
      const selectedMods = (draft.modules?.length ? draft.modules : selectedModules) ?? [];

      selectedMods.forEach(m => {
        if (!m.type && m.moduleRequirementCodeName) {
          m.type = m.moduleRequirementCodeName.includes("compulsory") ? "compulsory" : "elective";
        }
      })
      setSelectedModules(selectedMods);
      updateModuleCounts(selectedMods);

      const arr = [];
      selectedMods.forEach(m => { 
        arr.push({
          courseModuleId: m.courseModuleId,
          courseModuleGroupId: m.CourseModuleGroupId,
          type: m.type
        });
      });

      setValue("modules", arr, { shouldValidate: true });

      draft.workExperience.forEach(we => {
          if (we.typeOfOrganisationId) 
              we.typeOfOrganisationId = we.typeOfOrganisationId.toString();
      });

      draft.qualifications.forEach(qu => {
          if (qu.practicing) 
              qu.practicing = qu.practicing.toString().toLowerCase();
      });
      
      if (draft.entryCriteria) {
          const entryCriteria = draft.entryCriteria;
          draft.entryCriteria = formData.course.entryCriteria;          
          draft.entryCriteria.forEach((ec, index) => {
              const entryCriteriaItem = entryCriteria.find(ec2 => ec2.courseEntryCriteriaId == ec.courseEntryCriteriaId);
              if (entryCriteriaItem) {
                ec.courseApplicationEntryCriteriaId = entryCriteriaItem.courseApplicationEntryCriteriaId;
                ec.file = entryCriteriaItem.file;
                ec.fileId = entryCriteriaItem.fileId;
                ec.selection = entryCriteriaItem.selection;
              }              
              if (ec.selection) 
                ec.selection = ec.selection.toString();
          });
          
          const checkedEntryCriteriaLocal = {};
          draft.entryCriteria.forEach((ec, index) => {
              checkedEntryCriteriaLocal[index] = ec.selection;
          });
          setCheckedEntryCriteria(checkedEntryCriteriaLocal);
      }

      const model = {
        ...watch(),
        ...draft
      };

      if (!model.industryExperienceYears) {
        model.industryExperienceYears = null;
      }

      if (!model.fundingId) {
        model.fundingId = null;
      }
      else {
        model.fundingId = model.fundingId.toString();
      }

      reset(model);
    }
  }

  useEffect(() => {
    const subscription = watch((value) => console.log("Form Values:", value));
    return () => subscription.unsubscribe();
  }, [watch]);



  const steps = [
    {
      title: "Personal Information",
      validations: [
        "title", "firstName","lastName","email","courseCorrespondenceEmail",
        "genderId","nationalityId","countryOfResidenceId","homeAddress1","homeCity",
        "homePostcode","personalStatement"
      ],
      content: (
        <div style={{display: activeStep === "Personal Information" ? "block": "none"}}>
          <h2 className="text-xl text-brandDarkBlue font-bold mb-6">About you</h2>
            <InputField
                label="Title"
                name="title"
                register={register}
                rules={{ required: "Title is required" }}
                error={validatedSteps.includes(step) ? errors.title?.message : undefined}
            />
            <InputField 
                label="First name"
                name="firstName"
                register={register}
                rules={{ required: "First name is required" }}
                error={validatedSteps.includes(step) ? errors.firstName?.message : undefined}
            />
            <InputField 
                label="Middle name"
                name="middleName"
                register={register}
            />
            <InputField 
                label="Last name"
                name="lastName"
                register={register}
                rules={{ required: "Last name is required" }}
                error={validatedSteps.includes(step) ? errors.lastName?.message : undefined}

            />
            <InputField 
                label="Certificate name"
                name="certificateName"
                explanation="Name as you would like it to appear on your certificate"
                register={register}
            />
            <InputField 
                label="Email"
                name="email"
                register={register}
                rules={{ 
                  required: "Email is required",
                  pattern: { value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, message: "Email address must be a valid email address" }
                }}
                error={validatedSteps.includes(step) ? errors.email?.message : undefined}

            />
            <CheckboxField
                label="Send course emails to different email address"
                name="courseEmailsDifferentEmailAddress"
                register={register}
                onChange={handleDifferentEmailChecked}
            />
            {isDifferentEmailChecked && (
              <InputField 
                  label="Email to receive course notifications"
                  name="courseCorrespondenceEmail"
                  register={register}
                  rules={{ 
                    required: isDifferentEmailChecked ? "Email notifications address is required" : false,
                    pattern: { value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, message: "Email address must be a valid email address" }
                  }}
                  error={validatedSteps.includes(step) ? errors.emailNotifications?.message : undefined}

              />
            )}
            <InputField 
                label="Phone"
                name="phone"
                register={register}
            />
            <InputField 
                label="Mobile"
                name="mobile"
                register={register}
            />
            <SelectField
                label="Gender"
                name="genderId"
                defaultValue=""
                register={register}
                rules={{ required: "Gender is required" }}
                error={validatedSteps.includes(step) ? errors.gender?.message : undefined}
                options={formData.genders}
                valueField="itemId"
                textField="description"
            />
            <SelectField
                label="Nationality"
                name="nationalityId"
                defaultValue=""
                register={register}
                rules={{ required: "Nationality is required" }}
                error={validatedSteps.includes(step) ? errors.nationality?.message : undefined}
                options={formData.countries}
                valueField="countryId"
                textField="countryDisplayName"
            />
            <SelectField
                label="Country of residence"
                name="countryOfResidenceId"
                defaultValue=""
                register={register}
                rules={{ required: "Country of residence is required" }}
                options={formData.countries}
                valueField="countryId"
                textField="countryDisplayName"
            />
            <hr className="mt-6 border-t border-dashed" />
            <h2 className="text-xl text-brandDarkBlue font-bold my-6">Address</h2>
            <InputField 
                label="Home Address 1"
                name="homeAddress1"
                register={register}
                rules={{ required: "Home Address 1 is required" }}
                error={validatedSteps.includes(step) ? errors.homeAddress1?.message : undefined}
            />
            <InputField 
                label="Home Address 2"
                name="homeAddress2"
                register={register}
            />
            <InputField 
                label="City"
                name="homeCity"
                register={register}
                rules={{ required: "City is required" }}
                error={validatedSteps.includes(step) ? errors.homeCity?.message : undefined}
            />
            <InputField 
                label="State"
                name="homeState"
                register={register}
            />
            <InputField 
                label="Postcode"
                name="homePostcode"
                register={register}
                rules={{ required: "Postcode is required" }}
                error={validatedSteps.includes(step) ? errors.homePostcode?.message : undefined}
            />
            <CheckboxField
                label="Send course certificate to different address"
                name="courseCertificateAddress"
                type="checkbox"
                register={register}
                onChange={handlePostalAddressChecked}
            />
            {isPostalAddressChecked && (
              <>
              <InputField 
                  label="Postal Address 1"
                  name="postalAddress1"
                  register={register}
              />
              <InputField 
                  label="Postal Address 2"
                  name="postalAddress2"
                  register={register}
              />
              <InputField 
                  label="Postal City"
                  name="postalCity"
                  register={register}
              />
              <InputField 
                  label="Postal Postcode"
                  name="postalPostcode"
                  register={register}
              />
              </>
            )}
            <hr className="mt-6 border-t border-dashed" />
            <h2 className="text-xl text-brandDarkBlue font-bold my-6">Personal statement</h2>
            <TextAreaField 
                label="In no more than 250 words, please explain why you want to enrol for the course and what you hope to gain by doing so"
                name="personalStatement"
                register={register}
                rules={{
                  required: "Personal statement is required",
                  validate: {
                    maxWords: (value) => {
                        const wordCount = value.trim().split(/\s+/).length;
                        return wordCount <= 250 || "Personal statement must be no more than 250 words";
                    }
                  }
                }}
                error={validatedSteps.includes(step) ? errors.personalStatement?.message : undefined}
            />
        </div>)
    },
    {
      title: "Entry Criteria",
      validations: ["entryCriteria"],
      conditional: formData?.course?.entryCriteria && formData.course.entryCriteria.length > 0,
      content: (
        <div style={{display: activeStep === "Entry Criteria" ? "block": "none"}}>
          <p className="text-brandMidBlue text-md mb-4">Please note that applicants must meet all the entry criteria before they will be allowed to enrol on the course.</p>
          <p className="text-brandMidBlue text-md mb-4">Please confirm each of the following statements by clicking the relevant box:</p>
          {entryCriteriaFields.map((item, index) => {
            return (
              <div data-id={item.courseEntryCriteriaId} key={item.courseEntryCriteriaId}>
                {!item.isDouble ? (
                  <>
                    <CheckboxField
                      name={`entryCriteria[${index}].selection`}
                      label={item.statement}
                      explanation={item.clarification}
                      register={register}
                      value={1}
                      rules={{ required: "Entry criteria is required" }}
                      error={validatedSteps.includes(step)
                        ? getErrorMessage("entryCriteria", index, "selection")
                        : null}
                      onChange={(e) => handleEntryCriteriaChange(e, index)}
                    />
                    {checkedEntryCriteria[index] && item.fileUploadRequired && (
                      <UploadField 
                        label="Upload"
                        name={`entryCriteria[${index}].file`}
                        setValue={setValue}
                        register={register}
                        rules={!item.fileCanBeSentLater ? { required: 'This file is required' } : undefined}
                        error={validatedSteps.includes(step) && !item.fileCanBeSentLater
                        ? getErrorMessage("entryCriteria", index, "file_file")
                        : null}
                        defaultFile={watch(`entryCriteria[${index}]`)}
                      />
                    )}
                  </>
                ) : (
                  <>
                    <RadioField 
                      label="Please select which entry criteria you meet"
                      name={`entryCriteria[${index}].selection`}
                      register={register}
                      options={[
                        { value: 1, label: item.statement, explanation: item.clarification },
                        { value: 2, label: item.statement2, explanation: item.clarification2 }
                      ]}
                      rules={{ required: "Entry criteria is required" }}
                      error={validatedSteps.includes(step)
                        ? getErrorMessage("entryCriteria", index, "selection")
                        : null}
                      onChange={(e) => handleEntryCriteriaChange(e, index)}
                    />
                    {checkedEntryCriteria[index] === '1' && item.fileUploadRequired && (
                      <UploadField 
                        label="Upload"
                        name={`entryCriteria[${index}].file`}
                        setValue={setValue}
                        register={register}
                        rules={{ required: 'This file is required' }}
                        error={getErrorMessage("entryCriteria", index, "file_file")}
                        defaultFile={watch(`entryCriteria[${index}]`)}
                      />
                    )}
                    {checkedEntryCriteria[index] === '2' && item.fileUploadRequired2 && (
                      <UploadField 
                        label="Upload"
                        name={`entryCriteria[${index}].file`}
                        setValue={setValue}
                        register={register}
                        rules={!item.fileCanBeSentLater2 ? { required: 'This file is required' } : undefined}
                        error={validatedSteps.includes(step) && !item.fileCanBeSentLater2
                        ? getErrorMessage("entryCriteria", index, "file_file")
                        : null}
                        defaultFile={watch(`entryCriteria[${index}]`)}
                      />
                    )}
                  </>
                )}
                {entryCriteriaFields.length > index + 1 && <hr className="my-6 border-t border-dashed" />}
              </div>
            )
            })}
        </div>
      )
    },
    {
      title: "Employment Details",
      validations: ["workExperience","industryExperienceYears","industryExperienceSummary"],
      content: (
        <div style={{display: activeStep === "Employment Details" ? "block": "none"}}>
            {companyFields.map((item, index) => (
              <div key={"work-experience-" + index}>
                <div className="flex justify-between items-center">
                  <h2 className="text-xl text-brandDarkBlue font-bold my-6">Company {index + 1}</h2>
                  {index > 0 && (
                    <button type="button" onClick={() => removeCompany(index)} className="text-red underline font-medium whitespace-nowrap">
                      Remove
                    </button>
                  )}
                </div>
                <InputField 
                    label="Company"
                    name={`workExperience[${index}].company`}
                    register={register}
                    rules={{ required: "Company name is required" }}
                    error={validatedSteps.includes(step) ? errors?.workExperience?.[index]?.company?.message : undefined}

                />
                <InputField 
                    label="Company Address 1"
                    name={`workExperience[${index}].companyAddress1`}
                    register={register}
                />
                <InputField 
                    label="Company Address 2"
                    name={`workExperience[${index}].companyAddress2`}
                    register={register}
                />
                <InputField 
                    label="Company City"
                    name={`workExperience[${index}].companyCity`}
                    register={register}
                />
                <InputField 
                    label="Company State"
                    name={`workExperience[${index}].companyState`}
                    register={register}
                />
                <InputField 
                    label="Company Postcode"
                    name={`workExperience[${index}].companyPostcode`}
                    register={register}
                />
                <SelectField
                    label="Company Country"
                    name={`workExperience[${index}].companyCountryId`}
                    defaultValue=""
                    register={register}
                    rules={{ required: "Company Country is required" }}
                    options={formData.countries}
                    valueField="countryId"
                    textField="countryDisplayName"
                    error={validatedSteps.includes(step) ? errors?.workExperience?.[index]?.companyCountryId?.message : undefined}
                />
                <InputField 
                    label="Job title"
                    name={`workExperience[${index}].jobTitle`}
                    register={register}
                />
                <RadioField 
                    label="Type of organisation"
                    name={`workExperience[${index}].typeOfOrganisationId`}
                    register={register}
                    index={index}
                    options={formData.organisationTypes.map(ot => {return { value: ot.itemId, label: ot.description, codeName: ot.codeName }})}
                    onChange={(e) => handleTypeOfOrganisationOther(e, index)}
                    rules={{ required: "The type of organisation is required" }}
                    error={validatedSteps.includes(step) ? errors?.workExperience?.[index]?.typeOfOrganisationId?.message : undefined}
                />
                {isTypeOfOrganisationOther[index] && (
                  <InputField 
                      label="Please specify type of organisation"
                      name={`workExperience[${index}].otherTypeOfOrganisation`}
                      register={register}
                      rules={{
                        required: isTypeOfOrganisationOther[index] ? "Please specify type of organisation" : false,
                      }}
                      error={validatedSteps.includes(step) ? errors?.workExperience?.[index]?.otherTypeOfOrganisation?.message : undefined}
                  />
                )}
                <CustomDatePicker
                    label="Start Date"
                    name={`workExperience[${index}].startDate`}
                    register={register}
                    selectedDate={watch(`workExperience[${index}].startDate`)}
                    setValue={setValue}
                />
                <TextAreaField 
                    label="In no more than 250 words, please explain what your work and responsibilities were in this role"
                    name={`workExperience[${index}].jobDescription`}
                    register={register}
                    rules={{ required: "Work and responsibilities is required", max: 250 }}
                    error={validatedSteps.includes(step) ? errors?.workExperience?.[index]?.workResponsibilities?.message : undefined}
                />
                <hr className="my-6 border-t border-dashed" />
              </div>
            ))}
            <button type="button" onClick={addCompany} className="bg-brandMidBlue hover:bg-blue-700 text-white font-medium mb-6 py-2 px-6 rounded">
              Add Another
            </button>
            <InputField 
                label="Years in Insolvency and turnarounds"
                name="industryExperienceYears"
                register={register}
                rules={{ 
                  required: "Years in Insolvency and turnarounds is required",
                  pattern: { value: /^[0-9]+$/, message: "Years in Insolvency and turnarounds must be a valid integer" }
                }}
                error={validatedSteps.includes(step) ? errors.industryExperienceYears?.message : undefined}
            />
            <TextAreaField 
                label="In no more than 250 words, please explain your experience in cross-border insolvency and turnarounds"
                name="industryExperienceSummary"
                register={register}
                rules={{ required: "Cross-border insolvency and turnarounds explanation is required", max: 250 }}
                error={validatedSteps.includes(step) ? errors.industryExperienceSummary?.message : undefined}
            />
        </div>
      )
    },
    {
      title: "Educational and Professional Qualifications",
      validations: ["educationHistory","qualifications","references"],
      content: (
        <div style={{display: activeStep === "Educational and Professional Qualifications" ? "block": "none"}}>
          {formData?.course?.courseEducation > 0 && (
            <>
            {educationFields.map((item, index) => {
              return (
              <div key={"education-" + index}>
                <div className="flex justify-between items-center">
                  <h2 className="text-xl text-brandDarkBlue font-bold my-6">Education {index + 1}</h2>
                  {index >= formData.course.courseEducation && (
                    <button type="button" onClick={() => removeEducation(index)} className="text-red underline font-medium whitespace-nowrap">
                      Remove
                    </button>
                  )}
                </div>
                <InputField 
                    label="Degree"
                    name={`educationHistory[${index}].description`}
                    register={register}
                    rules={{required: "Degree is required" }}
                    error={validatedSteps.includes(step)
                        ? getErrorMessage("educationHistory", index, "description")
                        : null}
                />
                <InputField 
                    label="Year awarded"
                    name={`educationHistory[${index}].yearAwarded`}
                    register={register}
                    rules={{ 
                      required: "Year awarded is required",
                      pattern: { value: /^[0-9]+$/, message: "Year awarded must be a valid integer" }
                    }}
                    error={validatedSteps.includes(step)
                        ? getErrorMessage("educationHistory", index, "yearAwarded")
                        : null}
                />
                <InputField 
                    label="College/University"
                    name={`educationHistory[${index}].collegeUniversity`}
                    register={register}
                    rules={{ required: "College/University is required" }}
                    error={validatedSteps.includes(step)
                        ? getErrorMessage("educationHistory", index, "collegeUniversity")
                        : null}
                />
                <InputField 
                    label="Language of instruction"
                    name={`educationHistory[${index}].language`}
                    register={register}
                    rules={{ required: "Language of instruction is required" }}
                    error={validatedSteps.includes(step)
                        ? getErrorMessage("educationHistory", index, "language")
                        : null}
                />
                <UploadField 
                    label="Upload"
                    name={`educationHistory[${index}].file`}
                    setValue={setValue}
                    register={register}
                    rules={{ required: "This file is required" }}
                    error={validatedSteps.includes(step)
                        ? getErrorMessage("educationHistory", index, "file_file")
                        : null}
                    defaultFile={watch(`educationHistory[${index}]`)}
                />
                <hr className="my-6 border-t border-dashed" />
              </div>
            )})}
            <button type="button" onClick={addEducation} className="bg-brandMidBlue hover:bg-blue-700 text-white font-medium mb-6 py-2 px-6 rounded">
                Add Another
            </button>
            </>
          )}
          {formData?.course?.courseQualifications > 0 && (
            <>
            {professionalFields.map((item, index) => (
              <div key={"qualification-" + index}>
                <div className="flex justify-between items-center">
                  <h2 className="text-xl text-brandDarkBlue font-bold my-6">Professional Qualification {index + 1}</h2>
                  {index > 0 && (
                    <button type="button" onClick={() => removeProfessional(index)} className="text-red underline font-medium whitespace-nowrap">
                      Remove
                    </button>
                  )}
                </div>
                <InputField 
                    label="Qualification"
                    name={`qualifications[${index}].qualificationDescription`}
                    register={register}
                    rules={{ required: "Qualification is required" }}
                    error={validatedSteps.includes(step) ? errors?.qualifications?.[index]?.qualificationDescription?.message : undefined}
                />
                <CustomDatePicker
                    label="Date of Admission"
                    name={`qualifications[${index}].qualificationDate`}
                    register={register}
                    selectedDate={watch(`qualifications[${index}].qualificationDate`)}
                    setValue={setValue}
                />
                <InputField 
                    label="Profession"
                    name={`qualifications[${index}].profession`}
                    register={register}
                />
                <RadioField 
                    label="Have you been practicing?"
                    name={`qualifications[${index}].practicing`}
                    register={register}
                    options={[
                      { value: true, label: 'Yes' },
                      { value: false, label: 'No' },
                    ]}
                    //onChange={handleBeenPracticing}
                    //rules={{ required: "This field is required" }}
                    //error={errors.practicingNoPracticing?.message}
                />
                <hr className="my-6 border-t border-dashed" />
              </div>
            ))}
            <button type="button" onClick={addProfessional} className="bg-brandMidBlue hover:bg-blue-700 text-white font-medium mb-6 py-2 px-6 rounded">
                Add Another
            </button>
          </>
          )}
          {referencesFields.map((item, index) => (
            <div key={"reference-" + index}>
              <div className="flex justify-between items-center">
                <h2 className="text-xl text-brandDarkBlue font-bold my-6">Referee {index + 1}</h2>
              </div>
              <InputField
                label="Referee title"
                name={`references[${index}].title`}
                register={register}
                rules={{ required: "Referee title is required" }}
                error={validatedSteps.includes(step)
                    ? getErrorMessage("references", index, "titleId")
                    : null}
              />
              <InputField 
                  label="Referee first name"
                  name={`references[${index}].firstName`}
                  register={register}
                  rules={{ required: "Referee first name is required" }}
                  error={validatedSteps.includes(step)
                      ? getErrorMessage("references", index, "firstName")
                      : null}
              />
              <InputField 
                  label="Referee last name"
                  name={`references[${index}].lastName`}
                  register={register}
                  rules={{ required: "Referee last name is required" }}
                  error={validatedSteps.includes(step)
                      ? getErrorMessage("references", index, "lastName")
                      : null}
              />
              <InputField 
                  label="Referee email"
                  name={`references[${index}].email`}
                  register={register}
                  rules={{ 
                    required: "Referee email is required",
                    pattern: { value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, message: "Email address must be a valid email address" }
                  }}
                  error={validatedSteps.includes(step)
                      ? getErrorMessage("references", index, "email")
                      : null}
              />
              <InputField 
                  label="Referee tel country code"
                  name={`references[${index}].phoneCountryCode`}
                  register={register}
              />
              <InputField 
                  label="Referee phone"
                  name={`references[${index}].phone`}
                  register={register}
              />
              <InputField 
                  label="Referee home address 1"
                  name={`references[${index}].address1`}
                  register={register}
              />
              <InputField 
                  label="Referee home address 2"
                  name={`references[${index}].address2`}
                  register={register}
              />
              <InputField 
                  label="Referee city"
                  name={`references[${index}].city`}
                  register={register}
              />
              <InputField 
                  label="Referee state"
                  name={`references[${index}].state`}
                  register={register}
              />
              <InputField 
                  label="Referee postcode"
                  name={`references[${index}].postcode`}
                  register={register}
              />
              {referencesFields.length > index+1 && <hr className="my-6 border-t border-dashed" />}
            </div>
          ))}
        </div>
      )
    },
    {
      title: "Modules",
      conditional: !areAllModulesRequired,
      validations: ["yearsToComplete", "modules"],
      content: (
        <div style={{display: activeStep === "Modules" ? "block": "none"}}>
          {formData?.course?.applicationModulesSummary?.split("\n").map((line, index) => (
            <p key={index} className="text-brandMidBlue text-md mb-4">{line}</p>
          ))}
          <SelectField
              label="How many years would you like to complete the course?"
              name="yearsToComplete"
              //defaultValue=""
              register={register}
              rules={{ required: "The number of years to complete the course is required" }}
              error={validatedSteps.includes(step) ? errors.yearsToComplete?.message : undefined}
              options={["1", "2"]}
              //valueField="itemId"
              //textField="description"
          />

          {errors.modules && (
            <p className="text-red text-sm mb-6">You must select {formData.course.courseMinModules} modules.</p>
          )}
          {modulesFields.map((moduleGroup, index) => {
              return (
              <div key={"module-" + index}>
                <div className="flex items-center mb-6">
                  {(moduleGroup.requirementCodeName === "compulsory" || moduleGroup.requirementCodeName === "ab-compulsory") && (
                    <span className="font-bold text-red mr-2">*</span>
                  )}
                  <label className='text-brandMidBlue block text-sm font-bold'>
                    {moduleGroup.groupName}
                  </label>
                </div>

                {(moduleGroup.requirementCodeName === "ab-compulsory") && (
                    <p className="text-red text-xs mb-6">A module must be selected from this group.</p>
                )}
                
                {moduleGroup.modules.map((module, index) => {
                  const isCompulsory = moduleGroup.requirementCodeName === "compulsory";

                  return (
                    <CheckboxField
                        key={module.courseModuleId}
                        label={`${module.moduleName} ${getModuleType(module.courseModuleId, module.courseModuleGroupId, moduleGroup.requirementCodeName) ? ` ${getModuleType(module.courseModuleId, module.courseModuleGroupId, moduleGroup.requirementCodeName)}` : ''}`}
                        name={`modules[${module.courseModuleId}].selected`}
                        fontWeight="normal"
                        disabled={isCompulsory}
                        //checked={true}
                        //checked={module.selected || false}
                        checked={selectedModules.some(m => m.courseModuleId === module.courseModuleId)}
                        register={register}        
                        value={module.courseModuleId}
                        //value={1}
                        rules={{ validate: validateModules }}
                        error={validatedSteps.includes(step) ? errors.modules?.message : undefined}
                        onChange={(e) => !isCompulsory && handleModuleSelectionChange(e, module.courseModuleId, module.courseModuleGroupId, moduleGroup.requirementCodeName)}
                        //onChange={onChange}
                    />
                  )
                })}
              </div>
              )
          })}
        </div>
      )
    },
    {
      title: "Payment",
      validations: [
        "infoCertify", "terms", "fundingId", "paymentMethod",
        "billingName", "billingAddress1", "billingCity", "billingPostcode"
      ],
      content: (
        <div style={{display: activeStep === "Payment" ? "block": "none"}}>
              <h2 className="text-xl text-brandDarkBlue font-bold mb-6">Certification</h2>
              <p className="text-brandMidBlue text-md mb-4">By clicking the box below, you certify that all the information you have provided in this application is true and correct. If you are found to have submitted incomplete, untrue or incorrect information, INSOL reserves the right to immediately cancel your enrolment on the course and in such circumstances no refund of the course fee will be made.</p>
              <CheckboxField
                  label="I certify that the information I have provided is true and correct"
                  name="infoCertify"
                  type="checkbox"
                  register={register}
                  rules={{ required: "Please certify that the information provided is true and correct" }}
                  error={validatedSteps.includes(step) ? errors.infoCertify?.message : undefined}
                  onChange={(e) => setValue("infoCertify", e.target.checked ? 1 : 0, { shouldValidate: true })}
              />
              <h2 className="text-xl text-brandDarkBlue font-bold mb-6">Terms and Conditions</h2>
              <div className="h-48 overflow-auto bg-white p-6 mb-6 border border-brandDarkBlue" dangerouslySetInnerHTML={{ __html: formData.course.courseTerms }} />
              <CheckboxField
                  label="Please click here to confirm you have read and agree to our terms & conditions"
                  name="terms"
                  type="checkbox"
                  register={register}
                  rules={{ required: "Please acknowledge you have read and agreed to our terms & conditions" }}
                  error={validatedSteps.includes(step) ? errors.terms?.message : undefined}
                  onChange={(e) => setValue("terms", e.target.checked ? 1 : 0, { shouldValidate: true })}
              />
              <h2 className="text-xl text-brandDarkBlue font-bold mb-6">Register and Payment</h2>
              {formData.course.courseQuestionDiscountContent &&
              formData.course.courseQuestionDiscountContent.trim() !== "" &&
              formData.course.courseQuestionDiscount !== 0 && (
                <CheckboxField
                  label={formData.course.courseQuestionDiscountContent}
                  name="applyQuestionDiscount"
                  type="checkbox"
                  register={register}
                />
              )}
              <RadioField 
                  label="Who will pay?"
                  name="fundingId"
                  register={register}
                  options={formData.fundingTypes.map(ft => { return { value: ft.itemId, label: ft.description } })}
                  onChange={handleWhoWillPayOther}
                  rules={{ required: "Who will pay is required" }}
                  error={validatedSteps.includes(step) ? errors.fundingId?.message : undefined}
              />
              <p className="text-brandMidBlue text-md mb-4">Payment will not be taken until your place on the course has been confirmed.</p>
              <RadioField 
                label="Payment method"
                name="paymentMethod"
                register={register}
                options={[
                  { value: 'CARD', label: 'Debit or Credit Card' },
                  { value: 'BACS', label: 'BACS' }
                ]}
                onChange={handlePaymentMethod}
                rules={{ required: "Payment method is required" }}
                error={validatedSteps.includes(step) ? errors.paymentMethod?.message : undefined}
              />
              {paymentMethod && (
                <>
                <InputField 
                    label={whoWillPayOther === "2" ? "Company Name" : "Billing Name"}
                    name="billingName"
                    register={register}
                    rules={{ required: "Billing Name is required" }}
                    error={validatedSteps.includes(step) ? errors.billingName?.message : undefined}
                />
                <InputField 
                    label="Billing Address 1"
                    name="billingAddress1"
                    register={register}
                    rules={{ required: "Billing Address 1 is required" }}
                    error={validatedSteps.includes(step) ? errors.billingAddress1?.message : undefined}
                />
                <InputField 
                    label="Billing Address 2"
                    name="billingAddress2"
                    register={register}
                />
                <InputField 
                    label="Billing City"
                    name="billingCity"
                    register={register}
                    rules={{ required: "Billing City is required" }}
                    error={showErrorsForStep(step) ? errors.billingCity?.message : undefined}

                />
                <InputField 
                    label="Billing State"
                    name="billingState"
                    register={register}
                />
                <InputField 
                    label="Billing Postcode"
                    name="billingPostcode"
                    register={register}
                    rules={{ required: "Billing Postcode is required" }}
                    error={errors.billingPostcode?.message}
                />
                </>
              )}
              <CheckboxField
                label="Apply bursary discount"
                name="applyBursaryDiscount"
                register={register}
                onChange={handleBursaryDiscount}
            />
            {isBursaryDiscountChecked && (
              <InputField 
                  label="Enter discount code here"
                  name="discountCode"
                  register={register}
              />
            )}
        </div>
      )
    }
  ]

  const filteredSteps = steps.filter(step => step.conditional === undefined || step.conditional);

  const formatDate = (dateString) => {
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  if (formData.course.courseId) {
  const courseEnrollmentStartDate = new Date(formData.course.courseEnrollmentStartDate);
  const courseEnrollmentEndDate = new Date(formData.course.courseEnrollmentEndDate);
  const today = new Date();

  console.log('courseEnrollmentStartDate:', courseEnrollmentStartDate);
  console.log('courseEnrollmentEndDate:', courseEnrollmentEndDate);
  console.log('today:', today);

  const isBetweenDates = today >= courseEnrollmentStartDate && today <= courseEnrollmentEndDate;
  
  if (formHidden) {
    return (
      <div>
      {/* Hero */}
      <section className="hero hero--education relative h-80 bg-gradient-to-r from-darkHero to-lightHero text-white">
        <div className="container relative z-10 flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
          <header className="mt-auto mb-10">
            <h2 className="text-4.5xl text-white font-bold">{formData.course.courseTitle}</h2>
          </header>
          <div className="breadcrumbs mb-4">
            <ul className="flex">
              <li><Link className="white underline" to="/">Home</Link></li>
              <span className="breadcrumb-seperator mx-1">\</span>
              <li><Link className="white underline" to="/education/v1">Education</Link></li>
              <li className="breadcrumb-current">
                <span className="breadcrumb-seperator mx-1">\</span><span className="text-fontColor">{formData.course.courseTitle}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex absolute top-0 left-0 right-0 bottom-0">
          <img className="object-cover lg:object-contain lg:object-right ml-auto" src="https://insol.azureedge.net/cmsstorage/insol/media/heros/hero-arrow-education.png" alt="" />
        </div>
      </section>
      <section className="courses py-8 lg:py-12">
        <div className="flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-760">
            <div className='h-full text-sm p-20 w-full bg-brandGrey'>
              <h2 className="text-xl lg:text-4xl text-brandDarkBlue font-bold mb-6">Application</h2>
              <p className="text-brandMidBlue text-md mb-4">It looks like you have already applied to this course.</p>
            </div>
        </div>
      </section>
      </div>
    )
  }
  
  if (!isBetweenDates) {
    return (
      <div>
      {/* Hero */}
      <section className="hero hero--education relative h-80 bg-gradient-to-r from-darkHero to-lightHero text-white">
        <div className="container relative z-10 flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
          <header className="mt-auto mb-10">
            <h2 className="text-4.5xl text-white font-bold">{formData.course.courseTitle}</h2>
          </header>
          <div className="breadcrumbs mb-4">
            <ul className="flex">
              <li><Link className="white underline" to="/">Home</Link></li>
              <span className="breadcrumb-seperator mx-1">\</span>
              <li><Link className="white underline" to="/education/v1">Education</Link></li>
              <li className="breadcrumb-current">
                <span className="breadcrumb-seperator mx-1">\</span><span className="text-fontColor">{formData.course.courseTitle}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex absolute top-0 left-0 right-0 bottom-0">
          <img className="object-cover lg:object-contain lg:object-right ml-auto" src="https://insol.azureedge.net/cmsstorage/insol/media/heros/hero-arrow-education.png" alt="" />
        </div>
      </section>
      <section className="courses py-8 lg:py-12">
        <div className="flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-760">
            <div className='h-full text-sm p-20 w-full bg-brandGrey'>
              <h2 className="text-xl lg:text-4xl text-brandDarkBlue font-bold mb-6">Applications not open</h2>
              <p className="text-brandMidBlue text-md mb-4">Enrolment for the course is between {formatDate(formData.course.courseEnrollmentStartDate)} - {formatDate(formData.course.courseEnrollmentEndDate)}.</p>
            </div>
        </div>
      </section>
      </div>

    )}
  }

  return (
    <div>
      {/* Hero */}
      <section className="hero hero--education relative h-80 bg-gradient-to-r from-darkHero to-lightHero text-white">
        <div className="container relative z-10 flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
          <header className="mt-auto mb-10">
            <h2 className="text-4.5xl text-white font-bold">{formData.course.courseTitle}</h2>
          </header>
          {/* Breadcrumbs */}
          <div className="breadcrumbs mb-4">
            <ul className="flex">
              <li><Link className="white underline" to="/">Home</Link></li>
              <span className="breadcrumb-seperator mx-1">\</span>
              <li><Link className="white underline" to="/education/v1">Education</Link></li>
              <li className="breadcrumb-current">
                <span className="breadcrumb-seperator mx-1">\</span><span className="text-fontColor">{formData.course.courseTitle}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex absolute top-0 left-0 right-0 bottom-0">
          <img className="object-cover lg:object-contain lg:object-right ml-auto" src="https://insol.azureedge.net/cmsstorage/insol/media/heros/hero-arrow-education.png" alt="" />
        </div>
      </section>

      {/* My Courses */}
      <section className="courses py-8 lg:py-12" ref={formRef}>
          {isSubmitted ? (
            <div className="flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-760">
              <div className='h-full text-sm p-20 w-full bg-brandGrey'>
                <h2 className="text-xl lg:text-4xl text-brandDarkBlue font-bold mb-6">Confirmation</h2>
                <h2 className="text-xl text-brandDarkBlue font-bold mb-6">Thank you</h2>
                <p className="text-brandMidBlue text-md mb-4">Your application is now in review by the INSOL team.</p>
              </div>
            </div>
          ) : (
            <>
                  <div className="flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-760">
                    <StepProgressBar step={step + 1} totalSteps={filteredSteps.length} onBack={handleBack} />
                  </div>
                  <div className={`flex flex-col h-full mx-auto max-w-540 md:max-w-640 ${filteredSteps[step]?.title === "Modules" ? "gap-6 px-6 lg:flex-row lg:max-w-992 xl:max-w-90rem" : "lg:max-w-760"}`}>
                  <div className='h-full text-sm p-20 w-full bg-brandGrey order-2 lg:order-1'>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="flex items-center justify-between mb-6">
                        {step > 0 && (
                          <button type="button" onClick={handleBack} className="flex text-brandMidBlue underline">
                            Back
                          </button>
                        )}
                      </div>
                      {step === 0 && (
                        <p className="mb-6">By continuing, you agree that INSOL may collect and process the personal data you enter for the purpose of managing your application. Your progress may be saved automatically. All data is stored securely and processed in line with the GDPR and our <a target="_blank" href="https://www.insol.org/policies/privacy-policy">Privacy Policy</a>.</p>
                      )}
                      <h2 className="text-xl lg:text-4xl text-brandDarkBlue font-bold mb-6">
                        {step + 1} of {filteredSteps.length}: {filteredSteps[step]?.title}
                      </h2>
                      {filteredSteps.map(s => <>{s.content}</>)}
                      <div className="flex items-center justify-between mt-6">
                        {step > 0 && (
                          <button type="button" onClick={handleBack} className="flex text-brandMidBlue underline">
                            Back
                          </button>
                        )}
                        
                        {/* Continue button (for all steps except final "Submit" confirmation) */}
                        {step < filteredSteps.length - 1 && (
                          <button
                            onClick={async () => {
                              const currentStep = filteredSteps[step];
                              const isStepValid = currentStep.validations ? (await trigger(currentStep.validations)) : true;
                              setValidatedSteps((prev) => [...new Set([...prev, step])]);

                              debugger;
                              if (isStepValid) {
                                setStep(prevStep => prevStep + 1);
                                await saveDraft();
                                setActiveStep(filteredSteps[step + 1].title)
                              }
                            }}
                            className="bg-brandMidBlue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded ml-auto"
                            disabled={isSubmitting}
                          >
                            Continue
                          </button>
                        )}

                        {/* Continue payment preview button */}
                        {filteredSteps[step]?.title === "Payment" && !confirmPaymentPreview && (
                        <button
                          type="button"
                           onClick={async () => {
                            const userId = appContext.userId;

                            const revisedData = {
                              ...getValues(), // assuming you're using react-hook-form
                              courseId,
                              userId,
                              modules: selectedModules,
                              moduleGroups: null,
                            };

                            if (revisedData.entryCriteria?.length) {
                              revisedData.entryCriteria.forEach(ec => {
                                if (ec.selection === "1") ec.selection = 1;
                                else if (ec.selection === "2") ec.selection = 2;
                              });
                            }

                            if (revisedData.qualifications?.length) {
                              revisedData.qualifications.forEach(q => {
                                q.practicing = q.practicing === true || q.practicing === "true";
                              });
                            }

                            await handlePaymentPreview(revisedData);
                          }}
                          className="bg-brandMidBlue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded ml-auto"
                        >
                          Continue
                        </button>
                        )}

                        {/* Submit button (only shown after preview payment has been continued) */}
                        {filteredSteps[step]?.title === "Payment" && confirmPaymentPreview && (
                          <button
                            type="submit"
                            className={`${isSubmitting ? "bg-secondary-200" : "bg-brandMidBlue"} hover:bg-blue-700 text-white font-medium py-2 px-6 rounded ml-auto`}
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                          </button>
                        )}
                        
                      </div>
                    </form>
                  </div>
                  {/* Right Side - Sticky Sidebar */}
                  {filteredSteps[step]?.title === "Modules" && (
                    <div className="w-full lg:w-6/12 order-1 lg:order-2">
                      <div className="sticky top-6 bg-cloudBlue p-6">
                        <h3 className="text-lg font-bold text-brandDarkBlue mb-6">
                          Module Selection <span className="font-bold">{selectedModuleCount}/{formData.course.courseMinModules}</span>
                          {selectedModuleCount >= formData.course.courseMinModules && <span className="text-green-600"> ✅</span>}
                        </h3>

                        {/* Compulsory Modules */}
                        {(() => {
                          const { compulsoryCount } = getModuleCounts(selectedModules);
                          const totalRequiredCompulsory = modulesFields.filter(group => group.requirementCodeName === "compulsory" || group.requirementCodeName === "ab-compulsory").length;                          
                          return (
                            <>
                              <h4 className="text-md font-bold text-brandDarkBlue mb-2">
                                Compulsory Selected <span className="font-bold">{compulsoryCount}/{totalRequiredCompulsory}</span>
                                {compulsoryCount >= totalRequiredCompulsory && <span className="text-green-600"> ✅</span>}
                              </h4>
                              {compulsoryCount > 0 ? (
                                <ul className="list-disc pl-4 mb-4">
                                  {selectedModules
                                    .filter(m => m.type === "compulsory")
                                    .map(m => (
                                      <li key={m.courseModuleId} className="text-brandMidBlue text-sm">
                                        {modulesFields.flatMap(group => group.modules).find(mod => mod.courseModuleId === m.courseModuleId)?.moduleName || "Module Name Not Found"}
                                      </li>
                                    ))}
                                </ul>
                              ) : (
                                <p className="text-brandMidBlue text-sm mb-4">No compulsory modules selected.</p>
                              )}
                            </>
                          );
                        })()}

                        {/* Elective Modules */}
                        {(() => {
                          // Get all selected elective modules
                          const selectedElectiveModules = selectedModules.filter(m => m.type === "elective");

                          // Separate into "Regular" and "Additional" categories
                          const regularElectives = selectedElectiveModules.slice(0, 5); // Up to 5 electives
                          const additionalElectives = selectedElectiveModules.slice(5); // Beyond 5

                          return (
                            <>
                              <h4 className="text-md font-bold text-brandDarkBlue mb-2">
                                Elective Selected <span className="font-bold">{regularElectives.length}/{formData.course.courseMinElectiveModules}</span>
                                {regularElectives.length >= formData.course.courseMinElectiveModules && <span className="text-green-600"> ✅</span>}
                              </h4>
                              {regularElectives.length > 0 ? (
                                <ul className="list-disc pl-4 mb-4">
                                  {regularElectives.map(m => (
                                    <li key={m.courseModuleId} className="text-brandMidBlue text-sm">
                                      {modulesFields.flatMap(group => group.modules).find(mod => mod.courseModuleId === m.courseModuleId)?.moduleName || "Module Name Not Found"}
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <p className="text-brandMidBlue text-sm mb-4">No elective modules selected.</p>
                              )}

                              {/* Additional Modules Section */}
                              {additionalElectives.length > 0 && (
                                <>
                                  <h4 className="text-md font-bold text-brandDarkBlue mt-6 mb-2">
                                    Additional Modules <span className="font-bold">({additionalElectives.length} + £{(selectedAdditionalModules || 0) * (formData.course.courseAdditionalPricePerModule || 0)})</span>
                                  </h4>
                                  <ul className="list-disc pl-4 mb-4">
                                    {additionalElectives.map(m => (
                                      <li key={m.courseModuleId} className="text-brandMidBlue text-sm">
                                        {modulesFields.flatMap(group => group.modules).find(mod => mod.courseModuleId === m.courseModuleId)?.moduleName || "Module Name Not Found"}
                                      </li>
                                    ))}
                                  </ul>
                                </>
                              )}
                            </>
                          );
                        })()}

                        {/* Pricing */}
                        {/*
                        <h3 className="text-lg font-bold text-brandDarkBlue my-6">Price</h3>

                        <p className="text-brandMidBlue mb-2">
                          Course Price: <span className="font-bold">
                            £{(formData.course.coursePrice || 0) + ((selectedAdditionalModules || 0) * (formData.course.courseAdditionalPricePerModule || 0))}
                          </span>
                        </p>
                        */}
                      </div>
                    </div>
                  )}
              </div>
            </>
          )}

          


          {formError && (
            <Modal
                isOpen={showFormErrorModal}
                onClose={handleCloseFormErrorModal}
                className="max-w-xl"
            >
                <div className="p-6">
                    <h2 className="text-lg font-bold mb-4">Sorry, there was an error</h2>
                    <p>It looks like you may have missed a required filled, please go back and try again.</p>
                    <pre>{formError}</pre>
                    <div className="flex justify-end mt-4">
                        <button
                            onClick={handleCloseFormErrorModal}
                            className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full"
                        >
                            Continue
                        </button>
                    </div>
                </div>
            </Modal>
          )}
          {paymentPreview && (
            <Modal
                isOpen={showPaymentPreviewModal}
                onClose={handleClosePaymentPreviewModal}
                className="max-w-sm"
            >
                <div className="p-6">
                    <h2 className="text-lg font-bold mb-4">Your Course Price</h2>
                    <p className="mb-4">If the course price is not what you expected, please e-mail <a className="underline" href={formData.course.courseAdminEmail}>{formData.course.courseAdminName}</a>.</p>
                    <p className="mb-4">If the price is correct, please click "Continue" then "Submit" once more.</p>
                    <table className="table-auto w-full mb-4">
                        <thead>
                            <tr>
                                <td className="py-2 text-left">Course</td>
                                <td className="py-2 text-left">£{paymentPreview.price}</td>
                            </tr>
                            {paymentPreview.discount > 0 && (
                                <tr>
                                    <td className="py-2 text-left">Discount</td>
                                    <td className="py-2 text-left">-£{paymentPreview.discount}</td>
                                </tr>
                            )}
                            {paymentPreview?.tax > 0 && (
                                  <tr>
                                      <td className="py-2 text-left">VAT</td>
                                      <td className="py-2 text-left">£{paymentPreview.tax}</td>
                                  </tr>
                              )}
                            <tr className="border-t">
                                <td className="py-2 text-left">Total</td>
                                <td className="py-2 text-left">£{paymentPreview.totalAmountDue}</td>
                            </tr>
                        </thead>
                    </table>
                    <div className="flex justify-end mt-4">
                        <button
                            onClick={handleClosePaymentPreviewModal}
                            className="bg-uidark hover:bg-blue-700 text-uidarker font-medium py-2 px-6 mr-3 rounded-full"
                        >
                            Go back
                        </button>
                        <button
                            onClick={handleContinuePayment}
                            className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full"
                        >
                            Continue
                        </button>
                    </div>
                </div>
            </Modal>
          )}
      </section>

    </div>
  );
};

export default CourseApplication;